import React from 'react'
import getDisplayName from '../../../helpers/get-display-name'
import style from './index.scss'

export interface AngleMaskClassesProps {
  angleClasses: any
}

export type AngleMaskWrapperProps<P> = Pick<
  P,
  Exclude<keyof P, keyof AngleMaskClassesProps>
>

// See here for why we need to declare HOC like this:
// https://stackoverflow.com/questions/51083920/how-to-handle-props-injected-by-hoc-in-react-with-typescript
const withAngleMaskClasses = <P extends AngleMaskClassesProps>(
  Component: React.ComponentType<P>
): React.FC<AngleMaskWrapperProps<P>> => {
  const wrapper = (props: AngleMaskWrapperProps<P>): JSX.Element => (
    <Component angleClasses={style} {...props as P} />
  )

  const name = getDisplayName(Component)
  wrapper.displayName = `withAngleMaskClasses(${name})`
  return wrapper
}

export default withAngleMaskClasses
